/**
 * API-related constants
 */

export const API_CONSTANTS = {
  BASE_URL: '/api/sap/',
  ENDPOINTS: {
    FIND_BNS_BY_RADIUS: '/v0/find/bns/by-radius',
    HEALTH_API_KEY: '/v0/health/api-key',
    FIND_OPERATORS: '/v0/find/operators',
    FIND_OPERATORS_COUNTRY_LIST: '/v0/find/operators/country/list',
    PREDICT_SECTOR: '/v0/predict/sector',
    PREDICT_MULTI_SECTOR: '/v0/predict/multi-sector',
    SAP_REQUEST: 'sap-request',
    GET_SVG: '/get-svg',
  },
  DEFAULT_OPTIONS: 'url=suffix,csv_files=false',
  CSV_FILES_FALSE: 'csv_files=false',
} as const;

// Mapbox API constants
export const MAPBOX_API = {
  GEOCODING_BASE_URL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
  GEOCODING_FORMAT: '.json',
} as const;
